module.exports = __webpack_public_path__ + "media/frontend/components/calculators/images/cover-1a4395e1d00d8281a8353c704f335093.jpg";